import { authAxios } from "services";

export const fetchAll = (page) => authAxios().get(`/contact-messages?page=${page}`);

export const fetchById = (id) => authAxios().get(`/contact-messages/${id}`);

export const deleteById = (id) => authAxios().delete(`/contact-messages/${id}`);

export const updateById = (id, data) =>
  authAxios().post(`/contact-messages/${id}?_method=PUT`, data);
